const getNestedValue = (obj, path) => {
  if (!obj || !path) return undefined;
  return path.split(".").reduce((acc, key) => {
    if (!acc) return undefined;
    if (key.match(/^\\d+$/)) {
      if (typeof acc === "string") return undefined;
      return acc[Number(key)];
    }
    return acc[key];
  }, obj);
};

const getReadableError = (value) => {
  if (!value) return undefined;
  if (typeof value === "string") return value;
  if (Array.isArray(value)) {
    for (const item of value) {
      const nested = getReadableError(item);
      if (nested) return nested;
    }
    return undefined;
  }
  if (typeof value === "object") {
    for (const nestedValue of Object.values(value)) {
      const nested = getReadableError(nestedValue);
      if (nested) return nested;
    }
  }
  return undefined;
};

const ErrorMessage = ({ errors, touched, fieldName }) => {
  const error = getNestedValue(errors, fieldName);
  const isTouched = getNestedValue(touched, fieldName);
  const readableError = getReadableError(error);
  return readableError && isTouched ? (
    <span style={{ color: "red" }}>{readableError}</span>
  ) : null;
};

export default ErrorMessage
